import { render, staticRenderFns } from "./SimpleVerticalIndicator.vue?vue&type=template&id=06761327&scoped=true&"
import script from "./SimpleVerticalIndicator.vue?vue&type=script&lang=js&"
export * from "./SimpleVerticalIndicator.vue?vue&type=script&lang=js&"
import style0 from "./SimpleVerticalIndicator.vue?vue&type=style&index=0&id=06761327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06761327",
  null
  
)

component.options.__file = "SimpleVerticalIndicator.vue"
export default component.exports